import React from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import styles from "./webstories.m.css";
import { addWithoutAdsToTemplates } from "../get-collection-template";
import { LazyCollection } from "@quintype/components";
import { GA, WebEngage, DeepBI, PGAD } from "../../integrations";
import { DfpAd } from "../atoms/dfp-ad";

const newTemplates = addWithoutAdsToTemplates("election");
function getAdsWrappedCollectionTemplate(designTemplate) {
  return newTemplates[designTemplate] || newTemplates.defaultTemplate;
}

export class ElectionPage extends React.Component {
  componentDidMount() {
    GA.registerPageView(this.props.pageType, {});
    WebEngage.registerPageView();
    DeepBI.registerPageView({ collection: this.props });
    PGAD.loadScript();
  }

  render() {
    const sectionSlug = get(this.props.data, ["collection", "slug"], "");

    return (
      <div className={styles["lok-sabha-election-page"]}>
        {sectionSlug !== "" &&
          sectionSlug === "lok-sabha-election" && (
            <div className={`${styles["lok-sabha-election-banner"]} container`}>
              <div
                style={{
                  backgroundImage:
                    "url('https://media.vikatan.com/vikatan/2024-03/2e47da37-5e08-480e-a4af-d8208a3c356c/Election_microsite_mobile_banner.png')"
                }}
                className={`${styles["bg-image-sec"]} hidden-desktop`}
              >
                <h1>
                  இந்தியப் <br />
                  பொதுத் தேர்தல் <span>2024</span>
                </h1>
              </div>
              <div
                style={{
                  backgroundImage:
                    "url('https://media.vikatan.com/vikatan/2024-03/8f1e9b5d-36e3-4471-8902-add433e8dedb/Election_microsite_desktop_banner.png')"
                }}
                className={`${styles["bg-image-sec"]} hidden-mobile`}
              >
                <h1>
                  இந்தியப் <br />
                  பொதுத் தேர்தல் <span>2024</span>
                </h1>
              </div>
            </div>
          )}
        <LazyCollection
          collection={this.props.data.collection}
          magazine={this.props.data.magazine}
          config={this.props.config}
          collectionTemplates={getAdsWrappedCollectionTemplate}
          lazyAfter={4}
          accentColor={"#2f81cd"}
        />
        <DfpAd className="hidden-mobile" adtype="Roadblock" placement="home" hidetitle={true} />
        <DfpAd className="hidden-mobile" adtype="Subscription_Lightbox" placement="home" hidetitle={true} />
        <DfpAd className="hidden-desktop" adtype="Interstitial" placement="home" hidetitle={true} />
        <DfpAd className="hidden-desktop" adtype="Mobile_lightbox" placement="home" hidetitle={true} />
      </div>
    );
  }
}

ElectionPage.propTypes = {
  data: PropTypes.shape({
    collection: PropTypes.object,
    magazine: PropTypes.array
  }),
  pageType: PropTypes.string,
  config: PropTypes.shape({
    disableAds: PropTypes.bool,
    contentInsightsId: PropTypes.string
  })
};
